import { type LucideIcon } from 'lucide-react';
import type { PropsWithChildren, ReactNode } from 'react';

export function CountablePageHeader(
  props: PropsWithChildren<{
    title: string;
    totalCount: ReactNode;
    icon: LucideIcon;
  }>,
) {
  return (
    <div className="flex justify-between py-4">
      <div className="flex flex-col justify-between gap-1">
        <div className="flex items-center gap-2">
          <props.icon className="size-6" />
          <h1 className="text-2xl font-bold">{props.title}</h1>
        </div>
        <div className="text-muted-foreground relative translate-x-8 transform text-sm">
          {props.totalCount}
        </div>
      </div>

      {props.children}
    </div>
  );
}

export function PageHeader(props: {
  title: string;
  description?: string;
  icon: LucideIcon;
}) {
  return (
    <div className="grid w-full max-w-6xl gap-2 py-4">
      <div className="flex items-center gap-2">
        <props.icon className="size-6" />
        <h1 className="text-2xl font-bold">{props.title}</h1>
      </div>
      <p className="text-muted-foreground">{props.description}</p>
    </div>
  );
}
